import React from "react";
import Container from "./container/container";
import appStyles from "./app.module.css";
import { ConfigProvider } from "./context/config-context";

function App(props) {
  // Pass one of these values -> quote | plans | registration_fees | extra_fees | transfer_duties | structural_inspection_fees
  const config = {
    forModule: props?.module || "quote",
    defaultQuote: props?.defaultQuote || "conveyancing",
    internalQuote: props?.internalQuote || 0,
    template: props?.template || "",
    result_url: props?.result_url || "",
    employee: props?.employee || "",
  };
  return (
    <div className={appStyles.rezziPlugin}>
      <ConfigProvider value={config}>
        <Container />
      </ConfigProvider>
    </div>
  );
}

export default App;
